import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {ScriptCoreTree} from './coretree.script.js';

// import ambiant from './Aperture-Tag-OST-28-Central-Hub-_152kbit_Opus_.mp3';
import ambiant from './tree.mp3';

// import ambiant from './Aperture-Tag-OST-28-Central-Hub-_152kbit_Opus_.mp3';
// import ambiant2 from './Fountain Water Bubbling.mp3';

function gameobjectcoretree() {

    const coretree = new HYPERCUBEJS.Node('coretree');
    const meshcoretree = new HYPERCUBEJS.MeshIcosahedron('meshcoretree');
    const materialmeshcoretree = new HYPERCUBEJS.MaterialColor('materialmeshcoretree', {'color': [0.2, 0.5, 0.2]});

    meshcoretree.setmaterial(materialmeshcoretree);
    coretree.addmesh(meshcoretree);
    coretree.setaudio(new Audio(ambiant));
    coretree.setscript(new ScriptCoreTree());

    coretree.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-1, -1, -1],
        'max': [1, 1, 1]
    });

    return coretree;
}

export {

    gameobjectcoretree
};

export default gameobjectcoretree;
